import * as React from "react"

const MOBILE_BREAKPOINT = 768

// Calls back with whether the window is mobile width now and on every breakpoint crossing
function subscribeToMobileWidth(onChange: (isMobile: boolean) => void) {
  const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
  const report = () => {
    onChange(window.innerWidth < MOBILE_BREAKPOINT)
  }
  mql.addEventListener("change", report)
  report()
  return () => mql.removeEventListener("change", report)
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => subscribeToMobileWidth(setIsMobile), [])

  return !!isMobile
}
